import { render, staticRenderFns } from "./BrandAwareness.vue?vue&type=template&id=a95e4444"
import script from "./BrandAwareness.vue?vue&type=script&lang=js"
export * from "./BrandAwareness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports